import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"label":"Empresa","placeholder":"Selecione a empresa","items":_vm.items,"loading":_vm.loading,"readonly":_vm.disabled && _vm.model,"item-text":"fantasy_name","item-value":"id","rules":_vm.rules,"return-object":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }